import * as React from 'react';
const SvgCalenderIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#000"
      d="M15.347 3.833h-1.243v-.5c0-.5-.332-.833-.83-.833-.497 0-.829.333-.829.833v.5h-3.15c-.498 0-.83.334-.83.834 0 .5.332.833.83.833h3.233V6c0 .5.332.833.83.833.497 0 .829-.333.829-.833v-.5h1.243c.58 0 1.161.5 1.161 1.167v1.166H3.324V6.667c0-.667.58-1.167 1.244-1.167h1.244V6c0 .5.331.833.829.833.497 0 .83-.333.83-.833V3.333c0-.5-.333-.833-.83-.833-.498 0-.83.333-.83.833v.5H4.569c-1.658 0-2.902 1.25-2.902 2.834v8c0 1.583 1.244 2.833 2.902 2.833H15.43c1.576 0 2.902-1.25 2.902-2.833v-8c-.082-1.584-1.326-2.834-2.985-2.834Zm0 12H4.567c-.662 0-1.243-.5-1.243-1.166V9.5h13.267v5.167c0 .666-.58 1.166-1.244 1.166Z"
    />
  </svg>
);
export default SvgCalenderIcon;
